import { render } from "./editorJs.vue?vue&type=template&id=08693e9d&scoped=true"
import script from "./editorJs.vue?vue&type=script&lang=js"
export * from "./editorJs.vue?vue&type=script&lang=js"

import "./editorJs.vue?vue&type=style&index=0&id=08693e9d&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08693e9d"]])

export default __exports__